'use strict';

const SESSION_COOKIE_NAME = 'se';

const tracking = [
  '$rootScope',
  '$http',
  'Storage',

  function ($rootScope, $http, Storage) {
    var cookieStorage = new Storage('cookie');

    /**
     * Checks if session cookie exists.
     * @returns {boolean}
     */
    function checkCookie() {
      return !!cookieStorage.get(SESSION_COOKIE_NAME);
    }

    function sendTrackingData(shouldSaveData) {
      $http.post('/tracking', null, {
        params: {
          save: shouldSaveData
        }
      });
    }

    function extendSessionCookieExpiration() {
      var date = new Date();

      date.setMinutes(date.getMinutes() + 30);
      cookieStorage.set(SESSION_COOKIE_NAME, cookieStorage.get(SESSION_COOKIE_NAME), {
        path: '/',
        expires: date
      });
    }

    return {
      init: function () {
        $rootScope.$on('$stateChangeSuccess', function () {
          if (!checkCookie()) {
            sendTrackingData();
          } else {
            extendSessionCookieExpiration();
          }
        });
      },

      sendTrackingData: sendTrackingData
    };
  }
];

export default tracking;



// WEBPACK FOOTER //
// ./app/src/services/tracking.js